import { queryOptions, useQuery } from "@tanstack/react-query";
import { api } from "../apiClient";

export const getMember = ({ id, ...params }) => {
  return api.get(`admin/members/${id}`, {
    params,
  });
};

export const getMemberQueryOptions = params => {
  return queryOptions({
    queryKey: ["member", params],
    queryFn: () => getMember(params),
  });
};

export const useMemberQuery = ({ queryConfig = {}, ...params }) => {
  return useQuery({
    ...getMemberQueryOptions(params),
    ...queryConfig,
  });
};
